import { FilterItem } from './models/filter-item.interface';
import { DVFormControl } from '../../shared/helpers/dynamic-validators/dynamic-validator';
import { SelectionModel } from '@angular/cdk/collections/';

export class ReportUtils {
  public static filterArrayToFormArray(filterArray: Array<FilterItem>) {
    const outputObject = {};
    for (const filterItem of filterArray) {
      outputObject[filterItem.fieldName] = new DVFormControl(filterItem.defaultValue || null );
    }
    return outputObject;
  }
}

export class RSelectionModel<T = any> extends SelectionModel<T> {

  dataSource: Array<any>;
  constructor(dataSource: Array<any>, _multiple?: boolean, initiallySelectedValues?: any, _emitChanges?: boolean) {
    super(_multiple, initiallySelectedValues, _emitChanges);
    this.dataSource = dataSource;
  }

  isAllSelected() {
    const numSelected = this.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ? this.clear() : this.dataSource.forEach(row => this.select(row));
  }

  checkboxLabel(row?: T): string {
      if (!row) {
        return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
      }
      return `${this.isSelected(row) ? 'deselect' : 'select'} row`;
  }
}
